// @flow
import { takeEvery, put, call } from 'redux-saga/effects';
import { setIddCountry } from './actions';
import { CommonActions } from '@react-navigation/native';
import { getIddZoneCountries } from '../../../lib/country-utils';
import config from '../../../config';

import type { IDDActionType } from './actions';
import Navigation from '../../../lib/navigation';

export function* goToInternationalTopUpOfZoneSaga(action: IDDActionType): Generator<*, *, *> {
  if (action.type !== 'GO_TO_INTERNATIONAL_TOP_UP_OF_ZONE') return;
  const zoneCountries = getIddZoneCountries(config.iddCountries, action.payload.iddZone);
  yield put(setIddCountry(zoneCountries[0])); // We take any country in the IDD zone
  yield call(Navigation.dispatch, CommonActions.navigate({ name: 'chooseInternationalOptions' }));
}

export default function*(): Generator<*, *, *> {
  yield* [takeEvery('GO_TO_INTERNATIONAL_TOP_UP_OF_ZONE', goToInternationalTopUpOfZoneSaga)];
}
